export enum SPMakeOSProjectFolderStatuses {
  notCreated = 'notCreated',
  active = 'active',
  archived = 'archived',
}
